document.addEventListener("DOMContentLoaded", async function () {
   const custmerDataContainer = document.getElementById("customer-data");
   if(!custmerDataContainer) return;
    const userId = custmerDataContainer.getAttribute("data-customer-id");
  
    const apiUrl = "https://prod-srp.ultiwebtechnologies.com/api/view-customer-points";
    
    const payload = {
        shopify_user_id: userId,
       
    };
  console.log(payload);
    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        // if (!response.ok) throw new Error("Network response was not ok");
        
        const data = await response.json();
      
         if (data.status == "error") { 
           console.log("error");
           document.querySelector(".tire-status").style.display = "none";       
        }
      
        if (data.status === "success") {
            const apiData = data.data;
            console.log(apiData);

            const totalPurchaseAmount = apiData.total_purchase_amount;
            const totalCo2Savings =  apiData.total_co2_savings;
            const totalWaterSavings = apiData.total_water_savings;
            const totalPoints = apiData.total_points;
            const currentTier = apiData.current_tier;
            const nextTier = apiData.next_tier;
          
            let maxPurchaseAmount, currentColor, nextColor, rupeesPerPoint, purchaseToNextTier;
            const minimumThreshold = 0.2;  

    if (currentTier === "Green") {
        maxPurchaseAmount = 10000;
        currentColor = "#00ff00";
        nextColor = "#19AB19";
        rupeesPerPoint = 5;
        purchaseToNextTier = 10001 - totalPurchaseAmount;
      purchaseToNextTier = purchaseToNextTier.toFixed(2);
        divisionStep = 100;

      
        progressWidth = totalPurchaseAmount > 0
            ? Math.max((totalPurchaseAmount / maxPurchaseAmount) * 100, minimumThreshold * 100)
            : 0;

    } else if (currentTier === "Dark Green") {
    maxPurchaseAmount = 20000;
    currentColor = "#19AB19";
    nextColor = "#2e6f40";
    rupeesPerPoint = 7;
    purchaseToNextTier = 20001 - totalPurchaseAmount;
       purchaseToNextTier = purchaseToNextTier.toFixed(2);
    divisionStep = 200;

   
    progressWidth = totalPurchaseAmount > 10000
        ? Math.max(((totalPurchaseAmount - 10000) / (maxPurchaseAmount - 10000)) * 100, minimumThreshold * 100)
        : 0;

} else { 
    maxPurchaseAmount = 80000;  
    currentColor = "#2e6f40";
    nextColor = null;
    rupeesPerPoint = 10;
    purchaseToNextTier = 0;
    divisionStep = 500;

    // 20% threshold for initial progress; scaling with totalPurchaseAmount for Forest Green tier
    progressWidth = totalPurchaseAmount > 20000
        ? Math.max(((totalPurchaseAmount - 20000) / (maxPurchaseAmount - 20000)) * 100, minimumThreshold * 100)
        : 0;
}

    progressWidth = Math.min(progressWidth, 100);

    if(totalPoints==0){
        progressWidth = 0;
    }

            const formattedTotalPoints = !isNaN(totalPoints) ? totalPoints : '0.00';

          
            const sectionData = {
                buyMoreSaveMore: {
                    progressWidth: progressWidth,
                    tier: currentTier,
                    nextTier: nextTier,
                    tierColor: currentColor,
                    nextTierColor: nextColor,
                    progressColor: currentColor,
                    rupeesPerPoint: rupeesPerPoint,
                    purchaseToNextTier: purchaseToNextTier
                },
                envSavings: {
                    avoidedCOEmissions: totalCo2Savings,
                    waterSavings: totalWaterSavings,
                    amountSaved: formattedTotalPoints
                }
            };

           
            const buyMoreSaveMoreSection = document.getElementById('buy-more-save-more');
            const progressBar = document.querySelector('.progress-bar');
            const progressPercentage = document.querySelector('.progress-percentage');
            const currentTierElement = document.querySelector('.tier');
            const currentTierNameElement = document.querySelector('.tier-name');
            const currentTierSidebarElement = document.querySelector('.sidebar-tier');
          
         

            if (buyMoreSaveMoreSection) {
                buyMoreSaveMoreSection.style.setProperty('--progress-width', `${sectionData.buyMoreSaveMore.progressWidth}%`);
                buyMoreSaveMoreSection.style.setProperty('--progress-color', sectionData.buyMoreSaveMore.tierColor);
                progressBar.style.setProperty('width', `${sectionData.buyMoreSaveMore.progressWidth}%`);
                progressBar.style.setProperty('background-color', sectionData.buyMoreSaveMore.tierColor);
                progressPercentage.textContent = `${totalPoints} points`;

            }

            if (currentTierElement) {
                currentTierElement.textContent = sectionData.buyMoreSaveMore.tier;
                currentTierElement.style.color = sectionData.buyMoreSaveMore.tierColor;
                currentTierNameElement.textContent = sectionData.buyMoreSaveMore.tier;
                currentTierSidebarElement.textContent = sectionData.buyMoreSaveMore.tier;
            }

            // if (nextTierElement && sectionData.buyMoreSaveMore.nextTier) {
            //     nextTierElement.textContent = sectionData.buyMoreSaveMore.nextTier;
            //     nextTierElement.style.color = sectionData.buyMoreSaveMore.nextTierColor;
            // } else if (nextTierElement) {
            //     nextTierElement.textContent = "No further tier";
            //     nextTierElement.style.color = "#000";
            // }

            // if (rupeesPerPointElement) {
            //     rupeesPerPointElement.textContent = '₹ ' + sectionData.buyMoreSaveMore.rupeesPerPoint;
            // }

            // if (purchaseToNextTierElement) {
            //     purchaseToNextTierElement.textContent = sectionData.buyMoreSaveMore.purchaseToNextTier > 0 
            //         ? `Rs. ${sectionData.buyMoreSaveMore.purchaseToNextTier}`
            //         : "";
            //         if (currentTier === "Forest Green" && nextTierTransitionDetail) {
            //             nextTierTransitionDetail.textContent = "";
            //         } 
            // }

            const avoidedCOEmission = document.querySelector('.avoided-co-emission');
            const waterSaving = document.querySelector('.water-savings');
            // const amountSaved = document.querySelector('.amount-saved');
            console.log(avoidedCOEmission);
            console.log(sectionData.envSavings.avoidedCOEmissions);
            if (avoidedCOEmission) {
                avoidedCOEmission.textContent = sectionData.envSavings.avoidedCOEmissions;
            }
            if (waterSaving) {
                waterSaving.textContent = sectionData.envSavings.waterSavings;
            }
            // if (amountSaved) {
            //     amountSaved.textContent = sectionData.envSavings.amountSaved;
            // }
        } else {
            console.error("Failed to retrieve data:", data);
        }
    } catch (error) {
        console.error("Error fetching API data:", error);
    }
});
